<a id="shipowner" class="btn split-1">
    <h3>{{item.shipownerName}} <span>{{item.part}}%</span></h3>
    <p>{{item.shipownerAdminRef}}</p>
</a>